import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { userCompanies } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import UserCompaniesContent from '../../../../components/Dashboard/Workspace/UserCompaniesContent'
import { LanguageConsumer } from '../../../../LanguageContext'


const UserCompanies = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.userCompanies' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={userCompanies.image}
               description={intl.formatMessage({ id: 'PageTitle.userCompanies' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={<LanguageConsumer>
                      {({ locale }) => (
                        <UserCompaniesContent uid={id} handleNotificationCall={handleNotificationCall} locale={locale}/>
                      )}
                    </LanguageConsumer>}/> :
                    (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.workspace.home}/>
      }
    </>
  )
}

export default UserCompanies

